export default __webpack_public_path__ + "static/media/placeholder_private03-nl-web.7ce3450c.png";